export default __webpack_public_path__ + "static/SupremeLL-Italic-a2d8539642698c03cd2d03c64a9c0226.woff2";